// frontend/src/components/AGTHealth/services/agthealthMedicalAssistantService.js
import axios from 'axios';
import { getAuth } from 'firebase/auth';

// Configuración base para las peticiones al API según el entorno
const API_BASE = process.env.NODE_ENV === 'development'
  ? 'http://localhost:5004'
  : (process.env.REACT_APP_API_HEALTH_PATIENT_URL);

// Prefijo de API según entorno
const API_PREFIX = process.env.NODE_ENV === 'development' ? '/api' : '';

// URL completa
const API_URL = `${API_BASE}${API_PREFIX}`;

// Crear cliente axios
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true,
  timeout: 60000 // 60 segundos (las consultas a Claude pueden tardar)
});

// Interceptor para añadir token de autenticación
apiClient.interceptors.request.use(
  async (config) => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      
      if (user) {
        const token = await user.getIdToken();
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('Error al obtener token de Firebase:', error);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Servicio para el asistente médico
const agthealthMedicalAssistantService = {
  /**
   * Envía una consulta al asistente médico
   * @param {string} query - Consulta del usuario
   * @returns {Promise<Object>} - Respuesta del asistente
   */
  sendQuery: async (query) => {
    try {
      const response = await apiClient.post('/medical-assistant/query', { query });
      return response.data;
    } catch (error) {
      console.error('Error al enviar consulta al asistente médico:', error);
      return { 
        success: false, 
        message: 'Error al procesar tu consulta. Por favor intenta más tarde.',
        error: error.message || 'Error desconocido'
      };
    }
  }
};

export default agthealthMedicalAssistantService;